import { ReactElement } from 'react';

const FVSStep3AlertContent3 = (): ReactElement => (
  <div>
    <br />
    <p>The scheme allows your infringement fine(s) to be withdrawn only if:</p>
    <ul>
      <li>you are a victim of family violence, and</li>
      <li>
        the family violence was one of the main reasons why you were unable to:
        <ul>
          <li>control the conduct for which you received the fine, or</li>
          <li>name the driver that committed the offence.</li>
        </ul>
      </li>
    </ul>
  </div>
);

export default FVSStep3AlertContent3;
